import C from "./constants"
import Tile from "./Tile"
import Grid from './Grid'

export default class Level {
	constructor(level) {
		this.id = level.name
		this.introText = level.introText,
		this.countdownDuration = C.countdownDuration;
		this.flowSpeed = C.flowSpeed;
		this.distanceNeeded = level.distance;
		this.startTiles = level.startTiles;
		this.drawTileOptions = level.drawTiles;
		this.endTiles = level.endTiles;
		this.drawTiles = this.makeDrawPile(this.drawTileOptions,C.numDrawTiles);
		this.grid = new Grid(C.columns,C.rows);
		this.grid.startingCell.tile = new Tile(this.randomFrom(this.startTiles))
		this.grid.endingCell.tile = new Tile(this.randomFrom(this.endTiles))
	}
	get distanceRemaining(){
		if (this.distanceFilled >= this.distanceNeeded){
			return 0
		}
		return this.distanceNeeded - this.distanceFilled
	}
	get nextTile(){
		return this.drawTiles[this.drawTiles.length -1]
	}
	get distanceFilled(){
		let x = this.grid.cells.filter(cell => cell.tile && cell.tile.filled);
		let y = this.grid.cells.filter(cell => cell.tile && cell.tile.filled2);
		return x.length + y.length

	}

	makeDrawPile(fromArr,num) {
		let bag = [];
		let res = [];
		let id = 0;
		while (res.length < num) {
			bag.push(...fromArr);
			this.shuffle(bag);
			bag.forEach(item => {
				res.push(new Tile(item, id));
				id++
			})
		}
		return res
	}
	shuffle(arr) {
		for (let i = arr.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[arr[i], arr[j]] = [arr[j], arr[i]];
		}
		return arr;
	}
	randomFrom(arr){
		return arr[Math.floor(Math.random()*arr.length)]
	}
}

